import { Navigate, createFileRoute } from "@tanstack/react-router"
import { AssignmentStatus, AssignmentsTable } from "@/assignment"
import type { AssignmentsTableSearch } from "@/assignment"
import { BriefDetailPage } from "@/brief"
import { Feature, FeatureGate } from "@/feature"

// The briefs_ prefix un-nests this route from briefs.tsx (the list is a
// page, not a layout); the URL stays /t/$tenantSlug/briefs/$briefId
export const Route = createFileRoute("/(user)/t/$tenantSlug/briefs_/$briefId")({
  // The embedded assignments table keeps its status/page in the URL
  // (briefId is pinned from the path, so it is not a user filter here)
  validateSearch: (search): AssignmentsTableSearch => ({
    status: Object.values(AssignmentStatus).includes(
      search.status as AssignmentStatus,
    )
      ? (search.status as AssignmentStatus)
      : undefined,
    page:
      typeof search.page === "number" && search.page > 1
        ? search.page
        : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { tenantSlug, briefId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <FeatureGate
      feature={Feature.Briefs}
      otherwise={
        <Navigate
          to="/t/$tenantSlug/dashboard"
          params={{ tenantSlug }}
          replace
        />
      }
    >
      <BriefDetailPage
        briefId={briefId}
        assignments={
          <AssignmentsTable
            fixedFilter={{ briefId }}
            search={search}
            onSearchChange={(partial) => {
              void navigate({ search: (prev) => ({ ...prev, ...partial }) })
            }}
          />
        }
      />
    </FeatureGate>
  )
}
